import { render } from "./ContactBodyComponent.vue?vue&type=template&id=46665707&scoped=true"
import script from "./ContactBodyComponent.vue?vue&type=script&lang=js"
export * from "./ContactBodyComponent.vue?vue&type=script&lang=js"

import "./ContactBodyComponent.vue?vue&type=style&index=0&id=46665707&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46665707"]])

export default __exports__